$(document).ready(() => {
  let placeInLine = null;
  let waitingQueue = document.getElementById("waiting_queue");
  let waitingQueuePosition = document.getElementById("waiting_queue_position");
  let publicId = new URLSearchParams(window.location.search).get("id");

  if (waitingQueue) {
    App.waiting_list = App.cable.subscriptions.create(
      { channel: "WaitingListChannel", waiting_id: waitingQueue.dataset["waitingId"], public_id: publicId },
      {
        received(data) {
          if (data.place_in_line !== undefined) {
            placeInLine = data.place_in_line;
          } else if (data.job_done) {
            placeInLine -= 1;
          };

          if (placeInLine > 1) {
            waitingQueue.classList.remove("d-none");
            waitingQueuePosition.innerHTML = placeInLine;
          };
        }
      }
    );
  }
});
